// Croatian
export default {
  newVersionAvailable: 'Dostupna je nova verzija',
  versionInfo:
    'Dostupna je nova verzija aplikacije {appName}. Ponovno učitajte stranicu kako biste ažurirali na verziju {version}.',
  reload: 'Ponovno učitaj',
  later: 'Kasnije',
  intl_addr_country: 'Država',
  intl_addr_address1: 'Adresa',
  intl_addr_address2: 'Adresa 2',
  intl_addr_address3: 'Adresa 3',
  intl_addr_address4: 'Adresa 4',
  intl_addr_city: 'Grad',
  intl_addr_state: 'Županija',
  intl_addr_zipCode: 'Poštanski broj',
  intl_addr_longitude: 'Geografska dužina',
  intl_addr_latitude: 'Geografska širina',
  intl_addr_department: 'Odjel',
  intl_addr_suburb: 'Predgrađe',
  intl_addr_postalCode: 'Poštanski broj',
  intl_addr_province: 'Pokrajina',
  intl_addr_neighborhood: 'Susjedstvo',
};
